// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
        showPlaceholderProductList: true,
      placeholderImageRatio: 1.4, //It is used for ratio of image area of Skeleton product item. (height / width)
    placeholderProductGridItemClass: '',
    placeholderProductPerRow: 4,
    activeLoadPreviousPage: true ,
    paginationType: boostPFSConfig.custom.pagination_type.indexOf("load_more") != -1 ? "load_more" :
            (boostPFSConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' : 'default'),
  },
    selector: {
    trackingQuickView: '.quick_shop'
  }
};
// Declare Templates
var boostPFSTemplate = {
  // Grid Template
  'productGridItemHtml': '<div class="{{itemDesktopWidthClass}} medium-down--one-half {{itemMobileWidthClass}} column {{itemQuickShopClass}} {{itemSwapImageClass}} {{itemHoverImage}} {{itemStickersClass}}' +
  ' thumbnail product__thumbnail product__grid-item product__grid-more-item' +
  ' thumbnail__hover-overlay--{{itemHoverClass}}' +
  ' has-padding-bottom">' +
    '<div class="product-wrap">' +
        '<div class="product-image__wrapper">' +
                          '{{itemNewTag}}' +
            '<div class="image__container product__imageContainer">' +
                // '<a href="{{itemUrl}}">' +
                    '{{itemStickers}}' +
                    '{{itemImages}}' +
            '{{itemHover}}' +
                // '</a>' +
            '</div>' +
        '</div>' +
        '<div class="thumbnail__caption text-align-{{itemTextAlignClass}}">' +
            '{{itemProductInfo}}' +
            '{{itemWishList}}' +
        '</div>' +
    '</div>' +
    '{{itemSwatch}}' +
    '{{itemReviews}}' +
  '</div>',

  'itemHoverHtml' : '{{itemProductInfoHover}}' + '{{itemReviewsHover}}',

  'itemProductInfoHtml': '<div class="product-thumbnail">' +
    '{{itemVendor}}' +
    '<a href="{{itemUrl}}" class="product-thumbnail__title">{{itemTitle}}</a>' +
    '{{itemComingSoon}}' +
    '{{itemPrice}}' +
  '</div>',

  // Pagination Template
  'previousActiveHtml': '<a href="{{itemUrl}}" class="pagination-previous">'+ boostPFSConfig.label.previous +'</a>',
  'nextActiveHtml': '<a href="{{itemUrl}}" class="pagination-next">'+ boostPFSConfig.label.next +'</a>',
  'pageItemHtml': '<li><a class="pagination-link" href="{{itemUrl}}">{{itemTitle}}</a></li>',
  'pageItemSelectedHtml': '<li><a class="pagination-link is-current">{{itemTitle}}</a></li>',
  'pageItemRemainHtml': '<li><a class="pagination-ellipsis">…</a></li>',
  'paginateHtml': '<nav class="pagination paginate--both" role="navigation" aria-label="pagination">{{previous}}<ul class="pagination-list">{{pageItems}}</ul>{{next}}</nav>',

  // Sorting Template
  'sortingHtml': '<select aria-label="Sort by" class="sort_by">{{sortingItems}}</select>',
};

(function () {
  BoostPFS.inject(this);

    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
    if (!data) data = this.data;
      if (!index) index = this.index;
      if (!totalProduct) totalProduct = this.totalProduct;

      // Get Template
      var itemHtml = boostPFSTemplate.productGridItemHtml;

      // Add class
      var itemDesktopWidthClass = 'one-third';
      switch (boostPFSConfig.custom.products_per_row){
        case 1: itemDesktopWidthClass = 'one-whole'; break;
        case 2: itemDesktopWidthClass = 'one-half'; break;
        case 3: itemDesktopWidthClass = 'one-third'; break;
        case 4: itemDesktopWidthClass = 'one-fourth'; break;
        case 5: itemDesktopWidthClass = 'one-fifth'; break;
        case 6: itemDesktopWidthClass = 'one-sixth'; break;
        case 7: itemDesktopWidthClass = 'one-seventh'; break;
        case 8: itemDesktopWidthClass = 'one-eighth'; break;
      }
      itemHtml = itemHtml.replace(/{{itemDesktopWidthClass}}/g, itemDesktopWidthClass);
      itemHtml = itemHtml.replace(/{{itemMobileWidthClass}}/g, boostPFSConfig.custom.mobile_products_per_row == 1 ? 'small-down--one-whole' : 'small-down--one-half');
      itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, boostPFSConfig.custom.enable_quickshop ? 'quick-shop--true quick-shop--closed product-{{itemId}} js-product_section' : '');
      itemHtml = itemHtml.replace(/{{itemStickersClass}}/g, boostPFSConfig.custom.stickers_enabled ? 'has-thumbnail-sticker' : '');
      itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, boostPFSConfig.custom.thumbnail_hover_enabled.toString());
      itemHtml = itemHtml.replace(/{{itemSwapImageClass}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'swap--true' : '');
      itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'has-secondary-image-swap' : '');
      itemHtml = itemHtml.replace(/{{itemTextAlignClass}}/g, boostPFSConfig.custom.thumbnail_text_alignment);

      // Add stickers
      var itemStickers = buildStickers(data);
      itemHtml = itemHtml.replace(/{{itemStickers}}/g, itemStickers);

      // Add images
      var itemImages = buildImages(data);
      itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

      // Add new tag
      var itemNew = buildTags(data);
      itemHtml = itemHtml.replace(/{{itemNewTag}}/g, itemNew);

      // Add wish list
      var itemWishList = buildWishList(data);
      itemHtml = itemHtml.replace(/{{itemWishList}}/g, itemWishList);

      // Add hover elements
      var itemHover = buildHover(data);
      itemHtml = itemHtml.replace(/{{itemHover}}/g, itemHover);

      // Add product info
      itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, boostPFSTemplate.itemProductInfoHtml);

      // Add vendor
      var itemVendor = boostPFSConfig.custom.display_vendor ? '<span class="product-thumbnail__vendor">{{itemVendor}}</span>' : '';
      itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

      var collectionHandles = data.collections.map(x => x.handle);
      var isComingSoon = collectionHandles.indexOf('coming-soon') != -1;

      // Add coming soon
      if (isComingSoon){
          itemHtml = itemHtml.replace(/{{itemComingSoon}}/g, '<span>' + boostPFSConfig.label.coming_soon + '</span>');
          itemHtml = itemHtml.replace(/{{itemPrice}}/g, '');

      // Add price
      } else {
          itemHtml = itemHtml.replace(/{{itemComingSoon}}/g, '');
          itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
      }

      // Add swatch
      var itemSwatch = buildSwatch(data);
      itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatch);

      // Add reviews
      var itemReviews = boostPFSConfig.custom.enable_shopify_collection_badges && boostPFSConfig.custom.enable_shopify_review_comments ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' : '';
      if (boostPFSConfig.custom.thumbnail_hover_enabled){
          itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, itemReviews);
          itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
      } else {
          itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, '');
          itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
      }

      itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
      itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title.toLowerCase())
      
      itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
      itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
      return itemHtml;
    };
    const isTemplateB = $('#templateB').text();
    function buildStickers(data){
        var html = '';
        var stickers = [];
        if (boostPFSConfig.custom.stickers_enabled){
            var collections = data.collections.map(x => x.handle);
            var stickerCollections = ['best-seller', 'coming-soon', 'new', 'pre-order', 'staff-pick'];
            for (var i = 0; i < stickerCollections.length; i++){
                var stickerCollection = stickerCollections[i];
                if (collections.indexOf(stickerCollection) != -1){
                    var stickerText = boostPFSConfig.label[stickerCollection.replace('-', '_')];
                    var sticker = '<div class="'+ stickerCollection +'-sticker thumbnail-sticker sticker-'+ i +'"><span class="sticker-text">' + stickerText + '</span></div>';
                    stickers.push(sticker);
                }
            }

            var onSale = data.available && data.price_min < data.compare_at_price_max;
            // if (onSale){
            //     var sticker = '<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + boostPFSConfig.label.sale + '</span></div>';
            //     stickers.push(sticker);
            // }

            if (stickers.length > 0){
                html = 	'<div class="sticker-holder sticker-shape-'+ boostPFSConfig.custom.sticker_shape +' sticker-position-'+ boostPFSConfig.custom.sticker_position +'">' +
                            '<div class="sticker-holder__content sticker-holder__content--">' +
                                stickers.join('') +
                            '</div>'+
                        '</div>';
            }
        }
        return html;
    }

    function buildImages(data){
        const isSplitTest = new URLSearchParams(window.location.search).get('boost-pfs');
        var html = '';
        var images = data.images_info;
        const data_handle = data.handle;
        if (!images || images.length == 0){
            images.push({
                src: boostPFSAppConfig.general.no_image_url,
                width: 480,
                height: 480
            })
        }
        const found = images.findIndex(element => element.alt == 'primary_img');
        let primary_img = found > -1 && isTemplateB.trim() == "true" ? found : 0;

        let images_primary_img = images[primary_img];
        let images_secondary = images[1];

        if (isSplitTest) {
            images_primary_img = images[1];
            images_secondary = images[primary_img];
        }

        html += buildImageElement(images_primary_img, data_handle, 'primary--image alt-primary-image');

        if (boostPFSConfig.custom.show_secondary_image && images.length > 1){
            html += buildImageElement(images_secondary, data_handle, 'lazypreload secondary swap--visible', true);
        }

        return html;
    }

    function buildTags(data) {
        let html = '';
        let tagName = false;
        const tags = data.tags;
        tags.map((i)=>{
            const lowerCase = i.toLowerCase();
            if ((lowerCase == 'new' || lowerCase == 'back in stock') && data.available) {
                tagName = lowerCase;
            } else if (lowerCase === 'coming soon' && !data.available) {
                tagName = lowerCase;
            }
        })
        if(tagName) {
            html += `<div class='product__new-tag'>${tagName}</div>`;
        }
        return html;
    }

    function buildWishList (data) {
        const empi = data.id;
        const epi = data.variants[0].id;
        const pr = 200;
        const iu = data.images[1];

        let html = '';
        const vendor = data.vendor.toLowerCase();
        const countryCode = vendor.split('ksubi ')[1];
        // console.log('countryCode',countryCode)
        let du = '';
        switch (countryCode) {
            case 'uk':
                du = `https://ksubi.uk/`;
                break;
            case 'jp':
                du = `https://ksubi.jp/`;
                break;
            case 'eu':
                du = `https://ksubi.eu/`;
                break;
            case 'au':
                du = `https://ksubi.com.au/`;
                break;
            case 'us':
                du = `https://ksubi.com/`;
                break;
            case 'ca':
                du = `https://ksubistore.ca/`;
                break;
            case 'nz':
                du = `https://ksubi.co.nz/`;
            case 'uat':
                du = `https://ksubi-uat.myshopify.com/`;
                break;
        }
        du += `products/${data.handle}`;

        html += `<!-- Swym Wishlist Plus EPI Button-->
        <button data-with-epi="true" class="swym-button product-card-boost__hover swym-add-to-wishlist-view-product product_${empi}" data-swaction="addToWishlist" data-product-id="${empi}" data-variant-id="${epi}" data-product-url="${du}"></button>
        <!-- Swym Wishlist Plus EPI Button-->`

        return html;
    }

    function buildImageElement(image, data_handle, additionalClass, secondFlag) {
        var additionalClass = (typeof additionalClass !== 'undefined') ? additionalClass : '';
        var html = '';
        var heightStyle = '';
        var widthStyle = '';
        var aspectRatio = image.width / image.height;
        if (boostPFSConfig.custom.align_height){
            heightStyle += 'max-height: ' + boostPFSConfig.custom.collection_height + 'px;';
            widthStyle += 'width: calc(' + image.width + ' / ' + image.height + ' * ' + boostPFSConfig.custom.collection_height + 'px)';
            // widthStyle += 'width: '+ (aspectRatio * boostPFSConfig.custom.collection_height) +'px; max-width: '+ image.width +'px;';
        }

        var backgroundColor = boostPFSConfig.custom.image_loading_style == 'color' ? 'background: url('+ Utils.optimizeImage(image.src, '1x') +'); ' : '';
        var lowQualityImage = boostPFSConfig.custom.image_loading_style == 'blur-up' ? Utils.optimizeImage(image.src, '50x') : '';

        var collectionHandle = $('[data-collection-handle]').data('collection-handle');
        const windowWidth = $(window).width()
        let isHidden = (windowWidth < 991) ? 'style="opacity: 0;"' : ''
        html += `<a href="${collectionHandle ? `/products/${data_handle}` : `/products/${data_handle}`}" ${isHidden}>` +
                    '<div class="image-element__wrap' + (secondFlag ? ' productCard-secondaryImage ' : '' ) + '" style="' + backgroundColor + heightStyle + widthStyle + '">' +
                        '<img alt="{{itemTitle}}"'+
                            ' class="lazyload transition--'+ boostPFSConfig.custom.image_loading_style + ' ' + additionalClass + '"'+
                            (lowQualityImage && lowQualityImage !== '' ?
                            ' src="' + lowQualityImage + '"' : '' ) +
                            ' data-src="'+ Utils.optimizeImage(image.src, '1600x') +'"'+
                            ' data-sizes="auto"'+
                            ' data-aspectratio="' + aspectRatio +'"'+
                            ' data-srcset="' + bgset(image) +'"'+
                            ' srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
                            ' height="'+ image.height +'"'+
                            ' width="'+ image.width +'"'+
                            ' style="'+ heightStyle +'"'+
                        '/>' +
                    '</div>' +
                '</a>';
        return html;
    }

    function buildHover(data){
        var html = '';
        if (boostPFSConfig.custom.enable_quickshop || boostPFSConfig.custom.thumbnail_hover_enabled){
            html = boostPFSTemplate.itemHoverHtml;
            if (boostPFSConfig.custom.thumbnail_hover_enabled){
                let imgStr = '';
                const images = data.images_info;
                const handle = data.handle;
                const collectionHandle = $('[data-collection-handle]').data('collection-handle');
                const isSplitTest = new URLSearchParams(window.location.search).get('boost-pfs');

                if (isTemplateB.trim() == "true") {
                    let valueCopy = JSON.parse(JSON.stringify(images))
                    if ( $(window).width() < 991 ) {
                        const primary = valueCopy.findIndex(element => element.alt == 'primary_img');
                        let primary_img = primary > -1 && isTemplateB.trim() == "true" ? primary : 0;
                        const src = valueCopy[primary_img];
                        imgStr += `
                                <a href="${collectionHandle ? `/products/${handle}`  : `/products/${handle}`}" style="display: inline-block;" class="swap--visible">
                                    <img alt="" class="lazyload" style="display: inline-block;"
                                        data-src= ${src.src}
                                        data-sizes="auto">
                                </a>`
                        valueCopy.splice(primary_img,1)
                    }

                    const found = valueCopy.findIndex(element => element.alt == 'secondary_img');
                    let secondary_img = found > -1 && isTemplateB.trim() == "true" ? found : 1;
                    const src = valueCopy[secondary_img];

                    const foundPrimary = images.findIndex(element => element.alt == 'primary_img');
                    let primary_img = foundPrimary > -1 && isTemplateB.trim() == "true" ? foundPrimary : 0;
                    const src_primary = valueCopy[primary_img];

                    const which_src = (isSplitTest) ? src_primary : src;
                    const which_src_splice = (isSplitTest) ? primary_img : secondary_img;

                    if (which_src) {
                        imgStr += `
                            <a href="${collectionHandle ? `/products/${handle}` : `/products/${handle}`}" style="display: inline-block;" class="swap--visible">
                                <img alt="" class="lazyload" style="display: inline-block;"
                                    data-src= ${which_src.src}
                                    data-sizes="auto">
                            </a>`
                        valueCopy.splice(which_src_splice,1)
                    }
                    valueCopy.map((i)=>{
                        const src = i.src;
                        imgStr += `
                            <a href="${collectionHandle ? `/products/${handle}` : `/products/${handle}`}" style="display: inline-block;" class="swap--visible">
                                <img alt="" class="lazyload" style="display: inline-block;"
                                    data-src= ${src}
                                    data-sizes="auto">
                            </a>`
                    })

                } else {
                    if ( $(window).width() < 991 ) {
                        let flippedImages = ``

                        if (isSplitTest) {
                            const firstSecondImages = images.slice(0, 2)

                            firstSecondImages.reverse().map((x, index) => {
                                const src = x.src;
                                let firstSecondDataSrc = (index > 0) ? `data-src="${src}"` : `src="${src}"`
                                flippedImages += `
                                    <a href="${collectionHandle ? `/products/${handle}` : `/products/${handle}`}" style="display: inline-block;" class="swap--visible">
                                        <img alt="" class="lazyload" style="display: inline-block;"
                                            ${firstSecondDataSrc}
                                            data-sizes="auto">
                                    </a>`
                            })

                            imgStr += flippedImages

                            images.slice(2).map((i)=>{
                                const src = i.src;
                                imgStr += `
                                    <a href="${collectionHandle ? `/products/${handle}` : `/products/${handle}`}" style="display: inline-block;" class="swap--visible">
                                        <img alt="" class="lazyload" style="display: inline-block;"
                                            data-src="${src}"
                                            data-sizes="auto">
                                    </a>`
                            })
                        } else {
                            images.map((i, index)=>{
                                const src = i.src;
                                let firstSecondDataSrc = (index > 0) ? `data-src="${src}"` : `src="${src}"`
                                imgStr += `
                                    <a href="${collectionHandle ? `/products/${handle}` : `/products/${handle}`}" style="display: inline-block;" class="swap--visible">
                                        <img alt="" class="lazyload" style="display: inline-block;"
                                            ${firstSecondDataSrc}
                                            data-sizes="auto">
                                    </a>`
                            })
                        }
                    } else {
                        const toSlice = (isSplitTest) ? Number(0) : Number(1);
                        images.slice(toSlice).map((i, index)=>{
                            const src = i.src;
                            imgStr += `
                                <a href="${collectionHandle ? `/products/${handle}` : `/products/${handle}`}" style="display: inline-block;" class="swap--visible">
                                    <img alt="" class="lazyload" style="display: inline-block;"
                                        data-src="${src}"
                                        data-sizes="auto">
                                </a>`
                        })
                    }

                }

                if(!imgStr) {
                    imgStr += `<a href="${collectionHandle ? `/products/${handle}` : `/products/${handle}`}" style="display: inline-block;" class="swap--visible"></a>`
                }

                var itemProductInfoHover =
                    `<div class="quick-shop__info product-card-boost__hover">
                        <div class="thumbnail-overlay">
                            <div class="info text-align-center">
                                <div class='quick-shop__images-slider'>
                                    ${imgStr}
                                </div>
                            </div>
                        </div>
                    </div>`;
                html = html.replace(/{{itemProductInfoHover}}/g, itemProductInfoHover);
            } else {
                html = html.replace(/{{itemProductInfoHover}}/g, '');
                html = html.replace(/{{itemReviews}}/g, '');
            }
            // if (!boostPFSConfig.custom.enable_quickshop){
            //     html = html.replace(/{{itemQuickShop}}/g, '');
            // }
        }
        return html;
    }

    function buildPrice(data){
        let html = '';
        let onSale = data.compare_at_price_max > data.price_min;
        let soldOut = !data.available;
        let maxPrice = data.price_max;
        let priceVaries = data.price_max != data.price_min;
        let variants = data.variants;
        let originalPrice = 0;
        // KSUB-142 - Hide price for Gift Product on PLP
        // Prepare css class for insertion into the template later
        let isGiftCardProduct = (data.handle === "gift-cards") ? "hidden" : "";
        const vendor = data.vendor.toLowerCase();
        const countryCode = vendor.split('ksubi ')[1];
        let symbol = '$';
        switch (countryCode) {
            case 'uk':
                symbol = `£`;
                break;
            case 'jp':
                symbol = `¥`;
                break;
            case 'eu':
                symbol = `€`;
                break;
        }
        variants.map((i)=>{
            var comparePrice = i.compare_at_price;
            var price = i.price;
            if (price < comparePrice) {
                if(comparePrice > originalPrice) {
                    originalPrice = comparePrice;
                }
            }
        });

        const isComingSoon = data.tags.find(tag => tag.toLowerCase() === 'coming soon');

        // KSUB-142 - Hide price for Gift Product on PLP
        // Insert class to hide price for Gift Card product only.
        html += `<div class='product-thumbnail__prices ${isGiftCardProduct}'>`;

        if (soldOut) {
            if (data.price_min > 0) {
                if(priceVaries) {
                    if (isComingSoon) {
                        html += `<span class='product-thumbnail__price price original'>${symbol}${(data.price_max).toFixed(2)}</span>`;
                    } else {
                        html += `<span class='product-thumbnail__price price original product-thumbnail__sold-out'>${symbol}${(data.price_max).toFixed(2)}</span>`;
                        html += `<span class="money product-thumbnail__sold-out">${symbol}${(data.price_min).toFixed(2)}</span>`;
                    }
                }
                else {
                    html += `<span class='product-thumbnail__price price'>${symbol}${(data.price_max).toFixed(2)}</span>`;
                }
            }
            else {
                html += boostPFSConfig.custom.free_price_text;
            }
            if (!isComingSoon) {
                html += '<span class="product-thumbnail__sold-out sold-out"> - ' + boostPFSConfig.label.sold_out + '</span>';
            }
        }
        else {
            if (data.price_min > 0) {
                if(priceVaries || originalPrice) {
                    if (maxPrice < originalPrice) {
                        html += `<span class='product-thumbnail__price price original'>${symbol}${(originalPrice).toFixed(2)}</span>`;
                        html += `<span class="money sale">${symbol}${(data.price_min).toFixed(2)}</span>`;
                    }
                    else {
                        html += `<span class='product-thumbnail__price price original'>${symbol}${(maxPrice).toFixed(2)}</span>`;
                        html += `<span class="money sale">${symbol}${(data.price_min).toFixed(2)}</span>`;
                    }

                }
                else {
                    html += `<span class='product-thumbnail__price price'>${symbol}${(data.price_max).toFixed(2)}</span>`;
                }
            }
            else {
                html += boostPFSConfig.custom.free_price_text;
            }
        }

        html += `</div>`;
        return html;
    }

    function buildSwatch(data){
        let html = `<div class='product-thumbnail__swatch product-thumbnail__swatch-boost product-card__hover'>`;
        let instockOption = [];
        const variants = data.variants;
        const handle = data.handle;
        const collectionHandle = $('[data-collection-handle]').data('collection-handle');

        variants.map((i)=>{
            if(i.available) {
                const size = i.option_size;
                if(!instockOption.includes(size)) {
                    instockOption.push(size)
                }

            }
        })

        data.options_with_values.map((o)=>{
            if (o.name == 'size') {
                const optionValues = o.values;

                optionValues.map((v)=>{

                    if(instockOption.includes(v.title)){
                        html += `<a href='${collectionHandle ? `/products/${handle}?size=${v.title}` : `/products/${handle}?size=${v.title}`}' class='product-thumbnail__swatch-item' data-option=${v.title}>${v.title}</a>`
                    }
                    else {
                        html += `<a href='${collectionHandle ? `/products/${handle}?size=${v.title}` : `/products/${handle}?size=${v.title}`}' class='product-thumbnail__swatch-item sold-out' data-option=${v.title}>${v.title}</a>`
                    }
                })
            }
        })

        html += `</div>`;

        return html;
    }

    function bgset(image) {
      var bgset = '';
      if (image) {
        var aspect_ratio = image.width / image.height;

        if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
        if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
        if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
        if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
        if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
        if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
        if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
        if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
        if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
        if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
        if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
        if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
        if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
        if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
        if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
        if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
        if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
        if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
        bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
      }
      return bgset;
    }

    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
      if (!totalProduct) totalProduct = this.totalProduct

      // Get page info
      var currentPage = parseInt(Globals.queryParams.page);
      var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

      if (totalPage > 1) {
        var paginationHtml = boostPFSTemplate.paginateHtml;
        // Build Previous
        var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
        // Build Next
        var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);
        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }
        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
          if (pageArr[iPage] == '...') {
              pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
          } else {
              pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
          }
          pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
          pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
        return paginationHtml;
      }

      return '';
    };

    // Build Sorting
    ProductSorting.prototype.compileTemplate = function () {
        if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                // Build content
                var sortingItemsHtml = '';
                for (var k in sortingArr) {
                    sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
                }
                var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
                return html;
            }
        }
        return '';
    };

    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function(data, eventType) {
        if (!data) data = this.data
        if (!eventType) eventType = this.eventType

        window.newUpdatePaginationContent();

        if (boostPFSConfig.custom.enable_quickshop && data.length > 0) {
            var count = 0;
            data.forEach(function(product) {
                var url = Utils.buildProductItemUrl(product, true);
                jQ.ajax({
                    type: "GET",
                    url: url + '?view=boost-pfs-quickview',
                    success: function (result) {
                        if (jQ('[data-boost-pfs-quickshop-id="'+ product.id + '"]').length == 1){
                            jQ('[data-boost-pfs-quickshop-id="'+ product.id + '"]').replaceWith(result);
                        }
                        count++;
                        if (count == data.length){
                            buildTheme();
                            boostHoverProductHandler();
                            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
                        }
                    }
                });
            })
        } else {
            buildTheme();
        }
    };

    // Build additional elements
    FilterResult.prototype.afterRender = function(data, eventType) {};


    function buildTheme(){
        if (window.SPR) {
            SPR.initDomEls();
            SPR.loadBadges();
        }
        Shopify.PaymentButton.init();

        if (boostPFSConfig.custom.show_multiple_currencies) {
            convertCurrencies();
        }
    }

    function boostHoverProductHandler() {
        setTimeout(()=>{
            const $productCard = $('.product__grid-item');
            const $imageSlider = $productCard.find('.quick-shop__images-slider');
            $imageSlider.flickity({
                imagesLoaded: true,
                draggable: true,
                cellAlign: 'left',
                contain: true,
                freeScroll: false,
                wrapAround: true,
                pageDots: false,
                prevNextButtons: true,
                initialIndex: 0
              })

            $productCard.on('mouseenter touchstart',(e)=>{
                const $currentTarget = $(e.currentTarget);
                const mr_sliders = $(e.currentTarget).find('.mr-lazy-slider')
                const $quickShop = $currentTarget.find('.quick-shop__info');
                const $wishList = $currentTarget.find('.swym-button');
                const $swatch = $currentTarget.find('.product-thumbnail__swatch');
                $quickShop.removeClass('product-card-boost__hover');
                $wishList.removeClass('product-card-boost__hover');
                $swatch.removeClass('product-card__hover');
                mr_sliders.each(function(){
                    const $slider = $(this);
                    $slider.attr('srcset', $slider.data('srcset'));
                    $slider.attr('src', $slider.data('src'));
                });
            })

            $productCard.on('mouseleave',(e)=>{
                const $currentTarget = $(e.currentTarget);
                const $quickShop = $currentTarget.find('.quick-shop__info');
                const $wishList = $currentTarget.find('.swym-button');
                const $swatch = $currentTarget.find('.product-thumbnail__swatch');
                $quickShop.addClass('product-card-boost__hover');
                $wishList.addClass('product-card-boost__hover');
                $swatch.addClass('product-card__hover');
            })

        },100)
    }

    Api.setApiLocaleParams = function(params) {
      /* If this store has the multi-language feature */
      if (Settings.general.hasOwnProperty('published_locales')
            && typeof Settings.general.published_locales !== 'undefined'
        && Object.keys(Settings.general.published_locales).length >= 1
        && typeof Settings.general.current_locale != 'undefined') {
          /* Pass the locale param to our api. */
          params.locale = Settings.getSettingValue('general.current_locale');
      }
      return params;
    }
})();
